function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) : factory();
})(function () {
  'use strict';

  var _Expose, _Property;

  function iterator(input) {
    var _index = 0,
        col = 1,
        line = 1;
    return {
      curr: function curr() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return input[_index + n];
      },
      end: function end() {
        return input.length <= _index;
      },
      info: function info() {
        return {
          index: _index,
          col: col,
          line: line
        };
      },
      index: function index(n) {
        return n === undefined ? _index : _index = n;
      },
      next: function next() {
        var next = input[_index++];
        if (next == '\n') line++, col = 0;else col++;
        return next;
      }
    };
  } // I'll make it work first


  function parse(it) {
    var word = '',
        marks = [];
    var groups = [],
        result = {};

    while (!it.end()) {
      var c = it.curr();

      if (c == '(') {
        marks.push(c);
        word = '';
      } else if (c == ')' || c == ',') {
        if (/^\-\-.+/.test(word)) {
          if (!result.name) {
            result.name = word;
          } else {
            if (!result.alternative) {
              result.alternative = [];
            }

            result.alternative.push({
              name: word
            });
          }
        }

        if (c == ')') {
          if (marks[marks.length - 1] == '(') {
            marks.pop();
          } else {
            throw new Error('bad match');
          }
        }

        if (c == ',') {
          if (!marks.length) {
            groups.push(result);
            result = {};
          }
        }

        word = '';
      } else if (!/\s/.test(c)) {
        word += c;
      }

      it.next();
    }

    if (marks.length) {
      return [];
    }

    if (result.name) {
      groups.push(result);
    }

    return groups;
  }

  function parse_var(input) {
    input = input.trim();
    var result = [];

    if (!/^var\(/.test(input)) {
      return result;
    }

    var it = iterator(input);

    try {
      result = parse(it);
    } catch (e) {
      console.error(e && e.message || 'Bad variables.');
    }

    return result;
  }

  function make_array(arr) {
    return Array.isArray(arr) ? arr : [arr];
  }

  function join(arr) {
    var spliter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\n';
    return (arr || []).join(spliter);
  }

  function last(arr) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return arr[arr.length - n];
  }

  function first(arr) {
    return arr[0];
  }

  function clone(arr) {
    return JSON.parse(JSON.stringify(arr));
  }

  function shuffle(arr) {
    var ret = Array.from ? Array.from(arr) : arr.slice();
    var m = arr.length;

    while (m) {
      var i = ~~(Math.random() * m--);
      var t = ret[m];
      ret[m] = ret[i];
      ret[i] = t;
    }

    return ret;
  }

  function flat_map(arr, fn) {
    if (Array.prototype.flatMap) return arr.flatMap(fn);
    return arr.reduce(function (acc, x) {
      return acc.concat(fn(x));
    }, []);
  }

  var Tokens = {
    func: function func() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'func',
        name: name,
        arguments: []
      };
    },
    argument: function argument() {
      return {
        type: 'argument',
        value: []
      };
    },
    text: function text() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'text',
        value: value
      };
    },
    pseudo: function pseudo() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'pseudo',
        selector: selector,
        styles: []
      };
    },
    cond: function cond() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'cond',
        name: name,
        styles: [],
        arguments: []
      };
    },
    rule: function rule() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'rule',
        property: property,
        value: []
      };
    },
    keyframes: function keyframes() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'keyframes',
        name: name,
        steps: []
      };
    },
    step: function step() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        type: 'step',
        name: name,
        styles: []
      };
    }
  };
  var is = {
    white_space: function white_space(c) {
      return /[\s\n\t]/.test(c);
    },
    line_break: function line_break(c) {
      return /\n/.test(c);
    },
    number: function number(n) {
      return !isNaN(n);
    },
    pair: function pair(n) {
      return ['"', '(', ')', "'"].includes(n);
    },
    pair_of: function pair_of(c, n) {
      return {
        '"': '"',
        "'": "'",
        '(': ')'
      }[c] == n;
    }
  }; // This should not be in the parser
  // but I'll leave it here until the rewriting

  var symbols = {
    'π': Math.PI,
    '∏': Math.PI
  };

  function throw_error(msg, _ref) {
    var col = _ref.col,
        line = _ref.line;
    console.error("(at line ".concat(line, ", column ").concat(col, ") ").concat(msg));
  }

  function get_text_value(input) {
    if (input.trim().length) {
      return is.number(+input) ? +input : input.trim();
    } else {
      return input;
    }
  }

  function read_until(fn) {
    return function (it, reset) {
      var index = it.index();
      var word = '';

      while (!it.end()) {
        var c = it.next();
        if (fn(c)) break;else word += c;
      }

      if (reset) {
        it.index(index);
      }

      return word;
    };
  }

  function read_word(it, reset) {
    var check = function check(c) {
      return /[^\w@]/.test(c);
    };

    return read_until(check)(it, reset);
  }

  function read_keyframe_name(it) {
    return read_until(function (c) {
      return /[\s\{]/.test(c);
    })(it);
  }

  function read_line(it, reset) {
    var check = function check(c) {
      return is.line_break(c) || c == '{';
    };

    return read_until(check)(it, reset);
  }

  function read_step(it, extra) {
    var c,
        step = Tokens.step();

    while (!it.end()) {
      if ((c = it.curr()) == '}') break;

      if (is.white_space(c)) {
        it.next();
        continue;
      } else if (!step.name.length) {
        step.name = read_selector(it);
      } else {
        step.styles.push(read_rule(it, extra));
        if (it.curr() == '}') break;
      }

      it.next();
    }

    return step;
  }

  function read_steps(it, extra) {
    var steps = [];
    var c;

    while (!it.end()) {
      if ((c = it.curr()) == '}') break;else if (is.white_space(c)) {
        it.next();
        continue;
      } else {
        steps.push(read_step(it, extra));
      }
      it.next();
    }

    return steps;
  }

  function read_keyframes(it, extra) {
    var keyframes = Tokens.keyframes(),
        c;

    while (!it.end()) {
      if ((c = it.curr()) == '}') break;else if (!keyframes.name.length) {
        read_word(it);
        keyframes.name = read_keyframe_name(it);

        if (!keyframes.name.length) {
          throw_error('missing keyframes name', it.info());
          break;
        }

        continue;
      } else if (c == '{') {
        it.next();
        keyframes.steps = read_steps(it, extra);
        break;
      }
      it.next();
    }

    return keyframes;
  }

  function read_comments(it) {
    var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    it.next();

    while (!it.end()) {
      var c = it.curr();

      if (flag.inline) {
        if (c == '\n') break;
      } else {
        if ((c = it.curr()) == '*' && it.curr(1) == '/') break;
      }

      it.next();
    }

    if (!flag.inline) {
      it.next();
      it.next();
    }
  }

  function read_property(it) {
    var prop = '',
        c;

    while (!it.end()) {
      if ((c = it.curr()) == ':') break;else if (!is.white_space(c)) prop += c;
      it.next();
    }

    return prop;
  }

  function read_arguments(it) {
    var args = [],
        group = [],
        stack = [],
        arg = '',
        c;

    while (!it.end()) {
      c = it.curr();

      if (/[\('"`]/.test(c) && it.curr(-1) !== '\\') {
        if (stack.length) {
          if (c != '(' && c === last(stack)) {
            stack.pop();
          } else {
            stack.push(c);
          }
        } else {
          stack.push(c);
        }

        arg += c;
      } else if (c == '@') {
        if (!group.length) {
          arg = arg.trimLeft();
        }

        if (arg.length) {
          group.push(Tokens.text(arg));
          arg = '';
        }

        group.push(read_func(it));
      } else if (/[,)]/.test(c)) {
        if (stack.length) {
          if (c == ')') {
            stack.pop();
          }

          arg += c;
        } else {
          if (arg.length) {
            if (!group.length) {
              group.push(Tokens.text(get_text_value(arg)));
            } else {
              group.push(Tokens.text(arg));
            }

            if (arg.startsWith('±')) {
              var raw = arg.substr(1);
              var cloned = clone(group);
              last(cloned).value = '-' + raw;
              args.push(normalize_argument(cloned));
              last(group).value = raw;
            }
          }

          args.push(normalize_argument(group));
          group = [];
          arg = '';
          if (c == ')') break;
        }
      } else {
        if (symbols[c]) {
          c = symbols[c];
        }

        arg += c;
      }

      it.next();
    }

    return args;
  }

  function normalize_argument(group) {
    var result = group.map(function (arg) {
      if (arg.type == 'text' && typeof arg.value == 'string') {
        var value = String(arg.value);

        if (value.includes('`')) {
          arg.value = value = value.replace(/`/g, '"');
        }

        arg.value = value.replace(/\n+|\s+/g, ' ');
      }

      return arg;
    });
    var ft = first(result) || {};
    var ed = last(result) || {};

    if (ft.type == 'text' && ed.type == 'text') {
      var cf = first(ft.value);
      var ce = last(ed.value);

      if (typeof ft.value == 'string' && typeof ed.value == 'string') {
        if (is.pair(cf) && is.pair_of(cf, ce)) {
          ft.value = ft.value.slice(1);
          ed.value = ed.value.slice(0, ed.value.length - 1);
        }
      }
    }

    return result;
  }

  function seperate_func_name(name) {
    var fname = '',
        extra = '';

    if (/\D$/.test(name)) {
      return {
        fname: name,
        extra: extra
      };
    }

    for (var i = name.length - 1; i >= 0; i--) {
      var c = name[i];

      if (/[\d.]/.test(c)) {
        extra = c + extra;
      } else {
        fname = name.substring(0, i + 1);
        break;
      }
    }

    return {
      fname: fname,
      extra: extra
    };
  }

  function read_func(it) {
    var func = Tokens.func();
    var name = '@',
        c;
    var has_argument = false;
    it.next();

    while (!it.end()) {
      c = it.curr();
      var next = it.curr(1);

      if (c == '(') {
        has_argument = true;
        it.next();
        func.arguments = read_arguments(it);
        break;
      } else if (!has_argument && next !== '(' && !/[0-9a-zA-Z_\-.]/.test(next)) {
        name += c;
        break;
      } else {
        name += c;
      }

      it.next();
    }

    var _seperate_func_name = seperate_func_name(name),
        fname = _seperate_func_name.fname,
        extra = _seperate_func_name.extra;

    func.name = fname;

    if (extra.length) {
      func.arguments.unshift([{
        type: 'text',
        value: extra
      }]);
    }

    func.position = it.info().index;
    return func;
  }

  function read_value(it) {
    var text = Tokens.text(),
        idx = 0,
        skip = true,
        c;
    var value = [],
        stack = [];
    value[idx] = [];

    while (!it.end()) {
      c = it.curr();

      if (skip && is.white_space(c)) {
        it.next();
        continue;
      } else {
        skip = false;
      }

      if (c == '\n' && !is.white_space(it.curr(-1))) {
        text.value += ' ';
      } else if (c == ',' && !stack.length) {
        if (text.value.length) {
          value[idx].push(text);
          text = Tokens.text();
        }

        value[++idx] = [];
        skip = true;
      } else if (/[;}]/.test(c)) {
        if (text.value.length) {
          value[idx].push(text);
          text = Tokens.text();
        }

        break;
      } else if (c == '@') {
        if (text.value.length) {
          value[idx].push(text);
          text = Tokens.text();
        }

        value[idx].push(read_func(it));
      } else if (!is.white_space(c) || !is.white_space(it.curr(-1))) {
        if (c == '(') stack.push(c);
        if (c == ')') stack.pop();

        if (symbols[c]) {
          c = symbols[c];
        }

        text.value += c;
      }

      it.next();
    }

    if (text.value.length) {
      value[idx].push(text);
    }

    return value;
  }

  function read_selector(it) {
    var selector = '',
        c;

    while (!it.end()) {
      if ((c = it.curr()) == '{') break;else if (!is.white_space(c)) {
        selector += c;
      }
      it.next();
    }

    return selector;
  }

  function read_cond_selector(it) {
    var selector = {
      name: '',
      arguments: []
    },
        c;

    while (!it.end()) {
      if ((c = it.curr()) == '(') {
        it.next();
        selector.arguments = read_arguments(it);
      } else if (/[){]/.test(c)) break;else if (!is.white_space(c)) selector.name += c;

      it.next();
    }

    return selector;
  }

  function read_pseudo(it, extra) {
    var pseudo = Tokens.pseudo(),
        c;

    while (!it.end()) {
      if ((c = it.curr()) == '}') break;

      if (is.white_space(c)) {
        it.next();
        continue;
      } else if (!pseudo.selector) {
        pseudo.selector = read_selector(it);
      } else {
        var rule = read_rule(it, extra);

        if (rule.property == '@use') {
          pseudo.styles = pseudo.styles.concat(rule.value);
        } else {
          pseudo.styles.push(rule);
        }

        if (it.curr() == '}') break;
      }

      it.next();
    }

    return pseudo;
  }

  function read_rule(it, extra) {
    var rule = Tokens.rule(),
        c;

    while (!it.end()) {
      if ((c = it.curr()) == ';') break;else if (!rule.property.length) {
        rule.property = read_property(it);

        if (rule.property == '@use') {
          rule.value = read_var(it, extra);
          break;
        }
      } else {
        rule.value = read_value(it);
        break;
      }
      it.next();
    }

    return rule;
  }

  function read_cond(it, extra) {
    var cond = Tokens.cond(),
        c;

    while (!it.end()) {
      if ((c = it.curr()) == '}') break;else if (!cond.name.length) {
        Object.assign(cond, read_cond_selector(it));
      } else if (c == ':') {
        var pseudo = read_pseudo(it);
        if (pseudo.selector) cond.styles.push(pseudo);
      } else if (c == '@' && !read_line(it, true).includes(':')) {
        cond.styles.push(read_cond(it));
      } else if (!is.white_space(c)) {
        var rule = read_rule(it, extra);
        if (rule.property) cond.styles.push(rule);
        if (it.curr() == '}') break;
      }
      it.next();
    }

    return cond;
  }

  function read_property_value(extra, name) {
    var rule = '';

    if (extra && extra.get_custom_property_value) {
      rule = extra.get_custom_property_value(name);
    }

    return rule;
  }

  function evaluate_value(values, extra) {
    values.forEach && values.forEach(function (v) {
      if (v.type == 'text' && v.value) {
        var vars = parse_var(v.value);
        v.value = vars.reduce(function (ret, p) {
          var rule = '',
              other = '',
              parsed;
          rule = read_property_value(extra, p.name);

          if (!rule && p.alternative) {
            p.alternative.every(function (n) {
              other = read_property_value(extra, n.name);

              if (other) {
                rule = other;
                return false;
              }
            });
          }

          try {
            parsed = parse$1(rule, extra);
          } catch (e) {}

          if (parsed) {
            ret.push.apply(ret, parsed);
          }

          return ret;
        }, []);
      }

      if (v.type == 'func' && v.arguments) {
        v.arguments.forEach(function (arg) {
          evaluate_value(arg, extra);
        });
      }
    });
  }

  function read_var(it, extra) {
    it.next();
    var groups = read_value(it) || [];
    return groups.reduce(function (ret, group) {
      evaluate_value(group, extra);

      var _group = _slicedToArray(group, 1),
          token = _group[0];

      if (token.value && token.value.length) {
        ret.push.apply(ret, _toConsumableArray(token.value));
      }

      return ret;
    }, []);
  }

  function parse$1(input, extra) {
    var it = iterator(input);
    var Tokens = [];

    while (!it.end()) {
      var c = it.curr();

      if (is.white_space(c)) {
        it.next();
        continue;
      } else if (c == '/' && it.curr(1) == '*') {
        read_comments(it);
      } else if (c == '/' && it.curr(1) == '/') {
        read_comments(it, {
          inline: true
        });
      } else if (c == ':') {
        var pseudo = read_pseudo(it, extra);
        if (pseudo.selector) Tokens.push(pseudo);
      } else if (c == '@' && read_word(it, true) === '@keyframes') {
        var keyframes = read_keyframes(it, extra);
        Tokens.push(keyframes);
      } else if (c == '@' && !read_line(it, true).includes(':')) {
        var cond = read_cond(it, extra);
        if (cond.name.length) Tokens.push(cond);
      } else if (!is.white_space(c)) {
        var rule = read_rule(it, extra);
        if (rule.property) Tokens.push(rule);
      }

      it.next();
    }

    return Tokens;
  }

  function apply_args(fn) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return args.reduce(function (f, arg) {
      return f.apply(null, make_array(arg));
    }, fn);
  }

  function clamp(num, min, max) {
    return Math.max(min, Math.min(max, num));
  }

  function maybe(cond, value) {
    if (!cond) return '';
    return typeof value === 'function' ? value() : value;
  }

  function range(start, stop, step) {
    var count = 0,
        old = start;

    var initial = function initial(n) {
      return n > 0 && n < 1 ? .1 : 1;
    };

    var length = arguments.length;

    if (length == 1) {
      var _ref2 = [initial(start), start];
      start = _ref2[0];
      stop = _ref2[1];
    }

    if (length < 3) step = initial(start);
    var range = [];

    while (step >= 0 && start <= stop || step < 0 && start > stop) {
      range.push(start);
      start += step;
      if (count++ >= 1000) break;
    }

    if (!range.length) range.push(old);
    return range;
  }

  function alias_for(obj, names) {
    Object.keys(names).forEach(function (n) {
      obj[n] = obj[names[n]];
    });
    return obj;
  }

  function is_letter(c) {
    return /^[a-zA-Z]$/.test(c);
  }

  function lazy(fn) {
    var wrap = function wrap() {
      return fn;
    };

    wrap.lazy = true;
    return wrap;
  }

  function sequence(count, fn) {
    var ret = [];

    for (var i = 0; i < count; ++i) {
      ret.push(fn(i));
    }

    return ret;
  }

  function cell_id(x, y, z) {
    return 'cell-' + x + '-' + y + '-' + z;
  }

  var min = 1,
      max = 32,
      total = 32 * 32;

  function parse_grid(size) {
    var _replace$replace$spli = (size + '').replace(/\s+/g, '').replace(/[,，xX]+/g, 'x').split('x').map(Number),
        _replace$replace$spli2 = _slicedToArray(_replace$replace$spli, 3),
        x = _replace$replace$spli2[0],
        y = _replace$replace$spli2[1],
        z = _replace$replace$spli2[2];

    var max_xy = x == 1 || y == 1 ? total : max;
    var max_z = x == 1 && y == 1 ? total : min;
    var ret = {
      x: clamp(x || min, 1, max_xy),
      y: clamp(y || x || min, 1, max_xy),
      z: clamp(z || min, 1, max_z)
    };
    return Object.assign({}, ret, {
      count: ret.x * ret.y * ret.z
    });
  }

  function create_svg_url(svg, id) {
    if (id) {
      var blob = new Blob([svg], {
        type: 'image/svg+xml'
      });
      var url = URL.createObjectURL(blob);
      return "url(".concat(url, "#").concat(id, ")");
    } else {
      var encoded = encodeURIComponent(svg);
      return "url(\"data:image/svg+xml;utf8,".concat(encoded, "\")");
    }
  }

  function normalize_svg(input) {
    var xmlns = 'xmlns="http://www.w3.org/2000/svg"';

    if (!input.includes('<svg')) {
      input = "<svg ".concat(xmlns, ">").concat(input, "</svg>");
    }

    if (!input.includes('xmlns')) {
      input = input.replace(/<svg([\s>])/, "<svg ".concat(xmlns, "$1"));
    }

    return input;
  }

  function lerp(start, end, t) {
    return start * (1 - t) + end * t;
  }

  function _rand() {
    var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start;

    if (arguments.length == 1) {
      if (start == 1) start = 0;else if (start < 1) start /= 10;else start = 1;
    }

    return lerp(start, end, Math.random());
  }

  function _pick() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var args = items.reduce(function (acc, n) {
      return acc.concat(n);
    }, []);
    return args[~~(Math.random() * args.length)];
  }

  function unique_id() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return prefix + Math.random().toString(32).substr(2);
  }

  function by_unit(fn) {
    return function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var unit = get_unit(args);
      return restore(fn, unit).apply(null, args);
    };
  }

  function restore(fn, unit) {
    return function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      args = args.map(function (str) {
        return Number(String(str).replace(/\D+$/g, ''));
      });
      var result = fn.apply(null, args);

      if (!unit.length) {
        return result;
      }

      if (Array.isArray(result)) {
        return result.map(function (n) {
          return n + unit;
        });
      }

      return result + unit;
    };
  }

  function get_unit(values) {
    var unit = '';
    values.some(function (str) {
      var input = String(str).trim();
      if (!input) return '';
      var matched = input.match(/\d(\D+)$/);
      return unit = matched ? matched[1] : '';
    });
    return unit;
  }

  function by_charcode(fn) {
    return function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      var codes = args.map(function (n) {
        return String(n).charCodeAt(0);
      });
      var result = fn.apply(null, codes);
      return Array.isArray(result) ? result.map(function (n) {
        return String.fromCharCode(n);
      }) : String.fromCharCode(result);
    };
  }
  /**
   * Based on the Shunting-yard algorithm.
   */


  function _calc(input) {
    var expr = infix_to_postfix(input),
        stack = [];

    while (expr.length) {
      var top = expr.shift();
      if (/\d+/.test(top)) stack.push(top);else {
        var right = stack.pop();
        var left = stack.pop();
        stack.push(compute(top, Number(left), Number(right)));
      }
    }

    return stack[0];
  }

  var operator = {
    '*': 3,
    '/': 3,
    '%': 3,
    '+': 2,
    '-': 2,
    '(': 1,
    ')': 1
  };

  function get_tokens(input) {
    var expr = String(input);
    var tokens = [],
        num = '';

    for (var i = 0; i < expr.length; ++i) {
      var c = expr[i];

      if (operator[c]) {
        if (c == '-' && expr[i - 1] == 'e') {
          num += c;
        } else if (!tokens.length && !num.length && /[+-]/.test(c)) {
          num += c;
        } else {
          var _ref3 = last(tokens) || {},
              type = _ref3.type,
              value = _ref3.value;

          if (type == 'operator' && !num.length && /[^()]/.test(c) && /[^()]/.test(value)) {
            num += c;
          } else {
            if (num.length) {
              tokens.push({
                type: 'number',
                value: num
              });
              num = '';
            }

            tokens.push({
              type: 'operator',
              value: c
            });
          }
        }
      } else if (/\S/.test(c)) {
        num += c;
      }
    }

    if (num.length) {
      tokens.push({
        type: 'number',
        value: num
      });
    }

    return tokens;
  }

  function infix_to_postfix(input) {
    var tokens = get_tokens(input);
    var op_stack = [],
        expr = [];

    for (var i = 0; i < tokens.length; ++i) {
      var _tokens$i = tokens[i],
          type = _tokens$i.type,
          value = _tokens$i.value;

      if (type == 'number') {
        expr.push(value);
      } else if (type == 'operator') {
        if (value == '(') {
          op_stack.push(value);
        } else if (value == ')') {
          while (op_stack.length && last(op_stack) != '(') {
            expr.push(op_stack.pop());
          }

          op_stack.pop();
        } else {
          while (op_stack.length && operator[last(op_stack)] >= operator[value]) {
            var op = op_stack.pop();
            if (!/[()]/.test(op)) expr.push(op);
          }

          op_stack.push(value);
        }
      }
    }

    while (op_stack.length) {
      expr.push(op_stack.pop());
    }

    return expr;
  }

  function compute(op, a, b) {
    switch (op) {
      case '+':
        return a + b;

      case '-':
        return a - b;

      case '*':
        return a * b;

      case '/':
        return a / b;

      case '%':
        return a % b;
    }
  }

  var store = {};

  function memo$1(prefix, fn) {
    return function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      var key = prefix + args.join('-');
      if (store[key]) return store[key];
      return store[key] = fn.apply(null, args);
    };
  }

  function expand(fn) {
    return function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return fn.apply(null, flat_map(args, function (n) {
        return String(n).startsWith('[') ? build_range(n) : n;
      }));
    };
  }

  function Type(type, value) {
    return {
      type: type,
      value: value
    };
  }

  function get_tokens$1(input) {
    var expr = String(input);
    var tokens = [],
        stack = [];

    if (!expr.startsWith('[') || !expr.endsWith(']')) {
      return tokens;
    }

    for (var i = 1; i < expr.length - 1; ++i) {
      var c = expr[i];

      if (c == '-' && expr[i - 1] == '-') {
        continue;
      }

      if (c == '-') {
        stack.push(c);
        continue;
      }

      if (last(stack) == '-') {
        stack.pop();
        var from = stack.pop();
        tokens.push(from ? Type('range', [from, c]) : Type('char', c));
        continue;
      }

      if (stack.length) {
        tokens.push(Type('char', stack.pop()));
      }

      stack.push(c);
    }

    if (stack.length) {
      tokens.push(Type('char', stack.pop()));
    }

    return tokens;
  }

  var build_range = memo$1('build_range', function (input) {
    var tokens = get_tokens$1(input);
    return flat_map(tokens, function (_ref4) {
      var type = _ref4.type,
          value = _ref4.value;
      if (type == 'char') return value;

      var _value = _slicedToArray(value, 2),
          from = _value[0],
          to = _value[1];

      var reverse = false;

      if (from > to) {
        var _ref5 = [to, from];
        from = _ref5[0];
        to = _ref5[1];
        reverse = true;
      }

      var result = by_charcode(range)(from, to);
      if (reverse) result.reverse();
      return result;
    });
  });

  var Node = function Node(data) {
    _classCallCheck(this, Node);

    this.prev = this.next = null;
    this.data = data;
  };

  var Stack = /*#__PURE__*/function () {
    function Stack() {
      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

      _classCallCheck(this, Stack);

      this._limit = limit;
      this._size = 0;
    }

    _createClass(Stack, [{
      key: "push",
      value: function push(data) {
        if (this._size >= this._limit) {
          this.root = this.root.next;
          this.root.prev = null;
        }

        var node = new Node(data);

        if (!this.root) {
          this.root = this.tail = node;
        } else {
          node.prev = this.tail;
          this.tail.next = node;
          this.tail = node;
        }

        this._size++;
      }
    }, {
      key: "last",
      value: function last() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var node = this.tail;

        while (--n) {
          if (!node.prev) break;
          node = node.prev;
        }

        return node.data;
      }
    }]);

    return Stack;
  }();

  var cos = Math.cos,
      sin = Math.sin,
      sqrt = Math.sqrt,
      pow = Math.pow,
      PI = Math.PI;
  var DEG = PI / 180;

  function polygon(option, fn) {
    if (typeof arguments[0] == 'function') {
      fn = option;
      option = {};
    }

    if (!fn) {
      fn = function fn(t) {
        return [cos(t), sin(t)];
      };
    }

    var split = option.split || 120;
    var scale = option.scale || 1;
    var start = DEG * (option.start || 0);
    var deg = option.deg ? option.deg * DEG : PI / (split / 2);
    var points = [];

    for (var i = 0; i < split; ++i) {
      var t = start + deg * i;

      var _fn = fn(t),
          _fn2 = _slicedToArray(_fn, 2),
          x = _fn2[0],
          y = _fn2[1];

      points.push(x * 50 * scale + 50 + '% ' + (y * 50 * scale + 50 + '%'));
    }

    return option.type ? "polygon(".concat(option.type, ", ").concat(points.join(','), ")") : "polygon(".concat(points.join(','), ")");
  }

  function rotate(x, y, deg) {
    var rad = DEG * deg;
    return [x * cos(rad) - y * sin(rad), y * cos(rad) + x * sin(rad)];
  }

  var shapes = {
    circle: function circle() {
      return 'circle(49%)';
    },
    triangle: function triangle() {
      return polygon({
        split: 3,
        start: -90
      }, function (t) {
        return [cos(t) * 1.1, sin(t) * 1.1 + .2];
      });
    },
    rhombus: function rhombus() {
      return polygon({
        split: 4
      });
    },
    pentagon: function pentagon() {
      return polygon({
        split: 5,
        start: 54
      });
    },
    hexgon: function hexgon() {
      return polygon({
        split: 6,
        start: 30
      });
    },
    hexagon: function hexagon() {
      return polygon({
        split: 6,
        start: 30
      });
    },
    heptagon: function heptagon() {
      return polygon({
        split: 7,
        start: -90
      });
    },
    octagon: function octagon() {
      return polygon({
        split: 8,
        start: 22.5
      });
    },
    star: function star() {
      return polygon({
        split: 5,
        start: 54,
        deg: 144
      });
    },
    diamond: function diamond() {
      return 'polygon(50% 5%, 80% 50%, 50% 95%, 20% 50%)';
    },
    cross: function cross() {
      return "polygon(\n      5% 35%,  35% 35%, 35% 5%,  65% 5%,\n      65% 35%, 95% 35%, 95% 65%, 65% 65%,\n      65% 95%, 35% 95%, 35% 65%, 5% 65%\n    )";
    },
    clover: function clover() {
      var k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      k = clamp(k, 3, 5);
      if (k == 4) k = 2;
      return polygon({
        split: 240
      }, function (t) {
        var x = cos(k * t) * cos(t);
        var y = cos(k * t) * sin(t);
        if (k == 3) x -= .2;

        if (k == 2) {
          x /= 1.1;
          y /= 1.1;
        }

        return [x, y];
      });
    },
    hypocycloid: function hypocycloid() {
      var k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      k = clamp(k, 3, 6);
      var m = 1 - k;
      return polygon({
        scale: 1 / k
      }, function (t) {
        var x = m * cos(t) + cos(m * (t - PI));
        var y = m * sin(t) + sin(m * (t - PI));

        if (k == 3) {
          x = x * 1.1 - .6;
          y = y * 1.1;
        }

        return [x, y];
      });
    },
    astroid: function astroid() {
      return shapes.hypocycloid(4);
    },
    infinity: function infinity() {
      return polygon(function (t) {
        var a = .7 * sqrt(2) * cos(t);
        var b = pow(sin(t), 2) + 1;
        return [a / b, a * sin(t) / b];
      });
    },
    heart: function heart() {
      return polygon(function (t) {
        var x = .75 * pow(sin(t), 3);
        var y = cos(1 * t) * (13 / 18) - cos(2 * t) * (5 / 18) - cos(3 * t) / 18 - cos(4 * t) / 18;
        return rotate(x * 1.2, (y + .2) * 1.1, 180);
      });
    },
    bean: function bean() {
      return polygon(function (t) {
        var _ref6 = [pow(sin(t), 3), pow(cos(t), 3)],
            a = _ref6[0],
            b = _ref6[1];
        return rotate((a + b) * cos(t) * 1.3 - .45, (a + b) * sin(t) * 1.3 - .45, -90);
      });
    },
    bicorn: function bicorn() {
      return polygon(function (t) {
        return rotate(cos(t), pow(sin(t), 2) / (2 + sin(t)) - .5, 180);
      });
    },
    drop: function drop() {
      return polygon(function (t) {
        return rotate(sin(t), (1 + sin(t)) * cos(t) / 1.4, 90);
      });
    },
    pear: function pear() {
      return polygon(function (t) {
        return [sin(t), (1 + sin(t)) * cos(t) / 1.4];
      });
    },
    fish: function fish() {
      return polygon(function (t) {
        return [cos(t) - pow(sin(t), 2) / sqrt(2), sin(2 * t) / 2];
      });
    },
    whale: function whale() {
      return polygon({
        split: 240
      }, function (t) {
        var r = 3.4 * (pow(sin(t), 2) - .5) * cos(t);
        return rotate(cos(t) * r + .75, sin(t) * r * 1.2, 180);
      });
    },
    bud: function bud() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      n = clamp(n, 3, 10);
      return polygon({
        split: 240
      }, function (t) {
        return [(1 + .2 * cos(n * t)) * cos(t) * .8, (1 + .2 * cos(n * t)) * sin(t) * .8];
      });
    },
    alien: function alien() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      var _args$map = args.map(function (n) {
        return clamp(n, 1, 9);
      }),
          _args$map2 = _slicedToArray(_args$map, 5),
          _args$map2$ = _args$map2[0],
          a = _args$map2$ === void 0 ? 1 : _args$map2$,
          _args$map2$2 = _args$map2[1],
          b = _args$map2$2 === void 0 ? 1 : _args$map2$2,
          _args$map2$3 = _args$map2[2],
          c = _args$map2$3 === void 0 ? 1 : _args$map2$3,
          _args$map2$4 = _args$map2[3],
          d = _args$map2$4 === void 0 ? 1 : _args$map2$4,
          _args$map2$5 = _args$map2[4],
          e = _args$map2$5 === void 0 ? 1 : _args$map2$5;

      return polygon({
        split: 480,
        type: 'evenodd'
      }, function (t) {
        return [(cos(t * a) + cos(t * c) + cos(t * e)) * .31, (sin(t * b) + sin(t * d) + sin(t)) * .31];
      });
    }
  };
  var Expose = (_Expose = {
    index: function index(_ref7) {
      var count = _ref7.count;
      return function (_) {
        return count;
      };
    },
    row: function row(_ref8) {
      var x = _ref8.x;
      return function (_) {
        return x;
      };
    },
    col: function col(_ref9) {
      var y = _ref9.y;
      return function (_) {
        return y;
      };
    },
    depth: function depth(_ref10) {
      var z = _ref10.z;
      return function (_) {
        return z;
      };
    },
    size: function size(_ref11) {
      var grid = _ref11.grid;
      return function (_) {
        return grid.count;
      };
    }
  }, _defineProperty(_Expose, 'size-row', function sizeRow(_ref12) {
    var grid = _ref12.grid;
    return function (_) {
      return grid.x;
    };
  }), _defineProperty(_Expose, 'size-col', function sizeCol(_ref13) {
    var grid = _ref13.grid;
    return function (_) {
      return grid.y;
    };
  }), _defineProperty(_Expose, 'size-depth', function sizeDepth(_ref14) {
    var grid = _ref14.grid;
    return function (_) {
      return grid.z;
    };
  }), _defineProperty(_Expose, "id", function id(_ref15) {
    var x = _ref15.x,
        y = _ref15.y,
        z = _ref15.z;
    return function (_) {
      return cell_id(x, y, z);
    };
  }), _defineProperty(_Expose, "n", function n(_ref16) {
    var extra = _ref16.extra;
    return function (_) {
      return extra[0] || 0;
    };
  }), _defineProperty(_Expose, "N", function N(_ref17) {
    var extra = _ref17.extra;
    return function (_) {
      return extra[1] || 0;
    };
  }), _defineProperty(_Expose, "repeat", makeSequence('')), _defineProperty(_Expose, "multiple", makeSequence(',')), _defineProperty(_Expose, 'multiple-with-space', makeSequence(' ')), _defineProperty(_Expose, "pick", function pick(_ref18) {
    var context = _ref18.context;
    return expand(function () {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return pushStack(context, 'last_pick', _pick(args));
    });
  }), _defineProperty(_Expose, 'pick-n', function pickN(_ref19) {
    var context = _ref19.context,
        extra = _ref19.extra,
        position = _ref19.position;
    var counter = 'pn-counter' + position;
    return expand(function () {
      if (!context[counter]) context[counter] = 0;
      context[counter] += 1;
      var max = arguments.length;

      var _ref20 = extra || [],
          _ref21 = _slicedToArray(_ref20, 1),
          idx = _ref21[0];

      var pos = ((idx === undefined ? context[counter] : idx) - 1) % max;
      var value = pos < 0 || arguments.length <= pos ? undefined : arguments[pos];
      return pushStack(context, 'last_pick', value);
    });
  }), _defineProperty(_Expose, 'pick-d', function pickD(_ref22) {
    var context = _ref22.context,
        extra = _ref22.extra,
        position = _ref22.position;
    var counter = 'pd-counter' + position;
    var values = 'pd-values' + position;
    return expand(function () {
      if (!context[counter]) context[counter] = 0;
      context[counter] += 1;

      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      if (!context[values]) {
        context[values] = shuffle(args);
      }

      var max = args.length;

      var _ref23 = extra || [],
          _ref24 = _slicedToArray(_ref23, 1),
          idx = _ref24[0];

      var pos = ((idx === undefined ? context[counter] : idx) - 1) % max;
      var value = context[values][pos];
      return pushStack(context, 'last_pick', value);
    });
  }), _defineProperty(_Expose, 'last-pick', function lastPick(_ref25) {
    var context = _ref25.context;
    return function () {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var stack = context.last_pick;
      return stack ? stack.last(n) : '';
    };
  }), _defineProperty(_Expose, "rand", function rand(_ref26) {
    var context = _ref26.context;
    return function () {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      var transform_type = args.every(is_letter) ? by_charcode : by_unit;
      var value = transform_type(_rand).apply(null, args);
      return pushStack(context, 'last_rand', value);
    };
  }), _defineProperty(_Expose, 'rand-int', function randInt(_ref27) {
    var context = _ref27.context;
    return function () {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }

      var transform_type = args.every(is_letter) ? by_charcode : by_unit;
      var value = parseInt(transform_type(_rand).apply(null, args));
      return pushStack(context, 'last_rand', value);
    };
  }), _defineProperty(_Expose, 'last-rand', function lastRand(_ref28) {
    var context = _ref28.context;
    return function () {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var stack = context.last_rand;
      return stack ? stack.last(n) : '';
    };
  }), _defineProperty(_Expose, "calc", function calc() {
    return function (value) {
      return _calc(value);
    };
  }), _defineProperty(_Expose, "hex", function hex() {
    return function (value) {
      return parseInt(value).toString(16);
    };
  }), _defineProperty(_Expose, "svg", lazy(function (input) {
    if (input === undefined) return '';
    var svg = normalize_svg(input().trim());
    return create_svg_url(svg);
  })), _defineProperty(_Expose, 'svg-filter', lazy(function (input) {
    if (input === undefined) return '';
    var id = unique_id('filter-');
    var svg = normalize_svg(input().trim()).replace(/<filter([\s>])/, "<filter id=\"".concat(id, "\"$1"));
    return create_svg_url(svg, id);
  })), _defineProperty(_Expose, "var", function _var() {
    return function (value) {
      return "var(".concat(value, ")");
    };
  }), _defineProperty(_Expose, "shape", function shape() {
    return memo('shape-function', function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      type = type.trim();

      if (typeof shapes[type] === 'function') {
        for (var _len13 = arguments.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
          args[_key13 - 1] = arguments[_key13];
        }

        return shapes[type](args);
      }

      return '';
    });
  }), _Expose);

  function makeSequence(c) {
    return lazy(function (n, action) {
      if (!action || !n) return '';
      var count = clamp(n(), 0, 65536);
      return sequence(count, function (i) {
        return action(i + 1, count);
      }).join(c);
    });
  }

  function pushStack(context, name, value) {
    if (!context[name]) context[name] = new Stack();
    context[name].push(value);
    return value;
  }

  var Func = alias_for(Expose, {
    'm': 'multiple',
    'ms': 'multiple-with-space',
    'r': 'rand',
    'ri': 'rand-int',
    'lr': 'last-rand',
    'p': 'pick',
    'pn': 'pick-n',
    'pd': 'pick-d',
    'lp': 'last-pick',
    'rep': 'repeat',
    'i': 'index',
    'x': 'row',
    'y': 'col',
    'z': 'depth',
    's': 'size',
    'sx': 'size-row',
    'sy': 'size-col',
    'sz': 'size-depth',
    // legacy names
    'size-x': 'size-row',
    'size-y': 'size-col',
    'size-z': 'size-depth',
    'multi': 'multiple',
    'pick-by-turn': 'pick-n',
    'max-row': 'size-row',
    'max-col': 'size-col'
  });

  var is_seperator = function is_seperator(c) {
    return /[,，\s]/.test(c);
  };

  function skip_seperator(it) {
    while (!it.end()) {
      if (!is_seperator(it.curr(1))) break;else it.next();
    }
  }

  function parse$2(input) {
    var it = iterator(input);
    var result = [],
        stack = [];
    var group = '';

    while (!it.end()) {
      var c = it.curr();

      if (c == '(') {
        group += c;
        stack.push(c);
      } else if (c == ')') {
        group += c;

        if (stack.length) {
          stack.pop();
        }
      } else if (stack.length) {
        group += c;
      } else if (is_seperator(c)) {
        result.push(group);
        group = '';
        skip_seperator(it);
      } else {
        group += c;
      }

      it.next();
    }

    if (group) {
      result.push(group);
    }

    return result;
  }

  var all = [];

  function get_props(arg) {
    if (!all.length) {
      var props = new Set();

      for (var n in document.head.style) {
        if (!n.startsWith('-')) {
          props.add(n.replace(/[A-Z]/g, '-$&').toLowerCase());
        }
      }

      if (!props.has('grid-gap')) {
        props.add('grid-gap');
      }

      all = Array.from(props);
    }

    return arg && arg.test ? all.filter(function (n) {
      return arg.test(n);
    }) : all;
  }

  function build_mapping(prefix) {
    var reg = new RegExp("\\-?".concat(prefix, "\\-?"));
    return get_props(reg).map(function (n) {
      return n.replace(reg, '');
    }).reduce(function (obj, n) {
      return obj[n] = n, obj;
    }, {});
  }

  var props_webkit_mapping = build_mapping('webkit');
  var props_moz_mapping = build_mapping('moz');

  function prefixer(prop, rule) {
    if (props_webkit_mapping[prop]) {
      return "-webkit-".concat(rule, " ").concat(rule);
    } else if (props_moz_mapping[prop]) {
      return "-moz-".concat(rule, " ").concat(rule);
    }

    return rule;
  }

  var presets = {
    '4a0': [1682, 2378],
    '2a0': [1189, 1682],
    a0: [841, 1189],
    a1: [594, 841],
    a2: [420, 594],
    a3: [297, 420],
    a4: [210, 297],
    a5: [148, 210],
    a6: [105, 148],
    a7: [74, 105],
    a8: [52, 74],
    a9: [37, 52],
    a10: [26, 37],
    b0: [1000, 1414],
    b1: [707, 1000],
    b2: [500, 707],
    b3: [353, 500],
    b4: [250, 353],
    b5: [176, 250],
    b6: [125, 176],
    b7: [88, 125],
    b8: [62, 88],
    b9: [44, 62],
    b10: [31, 44],
    b11: [22, 32],
    b12: [16, 22],
    c0: [917, 1297],
    c1: [648, 917],
    c2: [458, 648],
    c3: [324, 458],
    c4: [229, 324],
    c5: [162, 229],
    c6: [114, 162],
    c7: [81, 114],
    c8: [57, 81],
    c9: [40, 57],
    c10: [28, 40],
    c11: [22, 32],
    c12: [16, 22],
    d0: [764, 1064],
    d1: [532, 760],
    d2: [380, 528],
    d3: [264, 376],
    d4: [188, 260],
    d5: [130, 184],
    d6: [92, 126],
    letter: [216, 279],
    legal: [216, 356],
    'junior-legal': [203, 127],
    ledger: [279, 432],
    tabloid: [279, 432],
    executive: [190, 254],
    postcard: [100, 148],
    'business-card': [54, 90],
    poster: [390, 540]
  };
  var modes = {
    portrait: 'p',
    pt: 'p',
    p: 'p',
    landscape: 'l',
    ls: 'l',
    l: 'l'
  };
  var unit = 'mm';

  function get_preset(name, mode) {
    name = String(name).toLowerCase(); // Default to landscape mode

    var _ref29 = presets[name] || [],
        _ref30 = _slicedToArray(_ref29, 2),
        h = _ref30[0],
        w = _ref30[1];

    if (modes[mode] == 'p') {
      var _ref31 = [h, w];
      w = _ref31[0];
      h = _ref31[1];
    }

    return [w, h].map(function (n) {
      return n + unit;
    });
  }

  function is_preset(name) {
    return !!presets[name];
  }

  var Property = (_Property = {}, _defineProperty(_Property, '@size', function size(value, _ref32) {
    var is_special_selector = _ref32.is_special_selector;

    var _parse$ = parse$2(value),
        _parse$2 = _slicedToArray(_parse$, 2),
        w = _parse$2[0],
        _parse$2$ = _parse$2[1],
        h = _parse$2$ === void 0 ? w : _parse$2$;

    if (is_preset(w)) {
      var _get_preset = get_preset(w, h);

      var _get_preset2 = _slicedToArray(_get_preset, 2);

      w = _get_preset2[0];
      h = _get_preset2[1];
    }

    return "\n      width: ".concat(w, ";\n      height: ").concat(h, ";\n      ").concat(is_special_selector ? '' : "\n        --internal-cell-width: ".concat(w, ";\n        --internal-cell-height: ").concat(h, ";\n      "), "\n    ");
  }), _defineProperty(_Property, '@min-size', function minSize(value) {
    var _parse$3 = parse$2(value),
        _parse$4 = _slicedToArray(_parse$3, 2),
        w = _parse$4[0],
        _parse$4$ = _parse$4[1],
        h = _parse$4$ === void 0 ? w : _parse$4$;

    return "min-width: ".concat(w, "; min-height: ").concat(h, ";");
  }), _defineProperty(_Property, '@max-size', function maxSize(value) {
    var _parse$5 = parse$2(value),
        _parse$6 = _slicedToArray(_parse$5, 2),
        w = _parse$6[0],
        _parse$6$ = _parse$6[1],
        h = _parse$6$ === void 0 ? w : _parse$6$;

    return "max-width: ".concat(w, "; max-height: ").concat(h, ";");
  }), _defineProperty(_Property, '@place-cell', function () {
    var map_left_right = {
      'center': '50%',
      '0': '0%',
      'left': '0%',
      'right': '100%',
      'top': '50%',
      'bottom': '50%'
    };
    var map_top_bottom = {
      'center': '50%',
      '0': '0%',
      'top': '0%',
      'bottom': '100%',
      'left': '50%',
      'right': '50%'
    };
    return function (value) {
      var _parse$7 = parse$2(value),
          _parse$8 = _slicedToArray(_parse$7, 2),
          left = _parse$8[0],
          _parse$8$ = _parse$8[1],
          top = _parse$8$ === void 0 ? '50%' : _parse$8$;

      left = map_left_right[left] || left;
      top = map_top_bottom[top] || top;
      var cw = 'var(--internal-cell-width, 25%)';
      var ch = 'var(--internal-cell-height, 25%)';
      return "\n        position: absolute;\n        left: ".concat(left, ";\n        top: ").concat(top, ";\n        width: ").concat(cw, ";\n        height: ").concat(ch, ";\n        margin-left: calc(").concat(cw, " / -2) !important;\n        margin-top: calc(").concat(ch, " / -2) !important;\n        grid-area: unset !important;\n      ");
    };
  }()), _defineProperty(_Property, '@grid', function grid(value, options) {
    var _value$split$map = value.split('/').map(function (s) {
      return s.trim();
    }),
        _value$split$map2 = _slicedToArray(_value$split$map, 2),
        grid = _value$split$map2[0],
        size = _value$split$map2[1];

    return {
      grid: parse_grid(grid),
      size: size ? this['@size'](size, options) : ''
    };
  }), _defineProperty(_Property, '@shape', memo$1('shape-property', function (value) {
    var _parse$9 = parse$2(value),
        _parse$10 = _toArray(_parse$9),
        type = _parse$10[0],
        args = _parse$10.slice(1);

    var prop = 'clip-path';
    if (!shapes[type]) return '';
    var rules = "".concat(prop, ": ").concat(shapes[type].apply(null, args), ";");
    return prefixer(prop, rules) + 'overflow: hidden;';
  })), _defineProperty(_Property, '@use', function use(rules) {
    if (rules.length > 2) {
      return rules;
    }
  }), _Property);

  function build_expr(expr) {
    return function (n) {
      return String(expr).replace(/(\d+)(n)/g, '$1*' + n).replace(/n/g, n);
    };
  }

  function _nth(input, curr, max) {
    var expr = build_expr(input);

    for (var i = 0; i <= max; ++i) {
      if (_calc(expr(i)) == curr) return true;
    }
  }

  var is$1 = {
    even: function even(n) {
      return !!(n % 2);
    },
    odd: function odd(n) {
      return !(n % 2);
    }
  };

  function even_or_odd(expr) {
    return /^(even|odd)$/.test(expr);
  }

  var Selector = {
    at: function at(_ref33) {
      var x = _ref33.x,
          y = _ref33.y;
      return function (x1, y1) {
        return x == x1 && y == y1;
      };
    },
    nth: function nth(_ref34) {
      var count = _ref34.count,
          grid = _ref34.grid;
      return function () {
        for (var _len14 = arguments.length, exprs = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          exprs[_key14] = arguments[_key14];
        }

        return exprs.some(function (expr) {
          return even_or_odd(expr) ? is$1[expr](count - 1) : _nth(expr, count, grid.count);
        });
      };
    },
    row: function row(_ref35) {
      var x = _ref35.x,
          grid = _ref35.grid;
      return function () {
        for (var _len15 = arguments.length, exprs = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
          exprs[_key15] = arguments[_key15];
        }

        return exprs.some(function (expr) {
          return even_or_odd(expr) ? is$1[expr](x - 1) : _nth(expr, x, grid.x);
        });
      };
    },
    col: function col(_ref36) {
      var y = _ref36.y,
          grid = _ref36.grid;
      return function () {
        for (var _len16 = arguments.length, exprs = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
          exprs[_key16] = arguments[_key16];
        }

        return exprs.some(function (expr) {
          return even_or_odd(expr) ? is$1[expr](y - 1) : _nth(expr, y, grid.y);
        });
      };
    },
    even: function even(_ref37) {
      var count = _ref37.count;
      return function (_) {
        return is$1.even(count - 1);
      };
    },
    odd: function odd(_ref38) {
      var count = _ref38.count;
      return function (_) {
        return is$1.odd(count - 1);
      };
    },
    random: function random() {
      return function () {
        var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .5;
        if (ratio >= 1 && ratio <= 0) ratio = .5;
        return Math.random() < ratio;
      };
    }
  }; // Expose all Math functions and constants.

  var methods = Object.getOwnPropertyNames(Math);
  var MathFunc = methods.reduce(function (expose, n) {
    expose[n] = function () {
      return function () {
        if (typeof Math[n] === 'number') return Math[n];

        for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
          args[_key17] = arguments[_key17];
        }

        return Math[n].apply(null, args.map(_calc));
      };
    };

    return expose;
  }, {});

  function is_host_selector(s) {
    return /^\:(host|doodle)/.test(s);
  }

  function is_parent_selector(s) {
    return /^\:(container|parent)/.test(s);
  }

  function is_special_selector(s) {
    return is_host_selector(s) || is_parent_selector(s);
  }

  function is_nil(s) {
    return s === undefined || s === null;
  }

  var Rules = /*#__PURE__*/function () {
    function Rules(tokens) {
      _classCallCheck(this, Rules);

      this.tokens = tokens;
      this.rules = {};
      this.props = {};
      this.keyframes = {};
      this.grid = null;
      this.coords = [];
      this.reset();
    }

    _createClass(Rules, [{
      key: "reset",
      value: function reset() {
        this.styles = {
          host: '',
          container: '',
          cells: '',
          keyframes: ''
        };
        this.coords = [];

        for (var key in this.rules) {
          if (key.startsWith('#cell')) {
            delete this.rules[key];
          }
        }
      }
    }, {
      key: "add_rule",
      value: function add_rule(selector, rule) {
        var rules = this.rules[selector];

        if (!rules) {
          rules = this.rules[selector] = [];
        }

        rules.push.apply(rules, make_array(rule));
      }
    }, {
      key: "pick_func",
      value: function pick_func(name) {
        return Func[name] || MathFunc[name];
      }
    }, {
      key: "compose_aname",
      value: function compose_aname() {
        for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
          args[_key18] = arguments[_key18];
        }

        return args.join('-');
      }
    }, {
      key: "compose_selector",
      value: function compose_selector(_ref39) {
        var x = _ref39.x,
            y = _ref39.y,
            z = _ref39.z;
        var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return "#".concat(cell_id(x, y, z)).concat(pseudo);
      }
    }, {
      key: "compose_argument",
      value: function compose_argument(argument, coords) {
        var _this = this;

        var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var result = argument.map(function (arg) {
          if (arg.type == 'text') {
            return arg.value;
          } else if (arg.type == 'func') {
            var fn = _this.pick_func(arg.name.substr(1));

            if (fn) {
              coords.extra = extra;
              coords.position = arg.position;
              var args = arg.arguments.map(function (n) {
                return fn.lazy ? function () {
                  for (var _len19 = arguments.length, extra = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
                    extra[_key19] = arguments[_key19];
                  }

                  return _this.compose_argument(n, coords, extra);
                } : _this.compose_argument(n, coords, extra);
              });
              return apply_args(fn, coords, args);
            }
          }
        });
        return result.length >= 2 ? result.join('') : result[0];
      }
    }, {
      key: "compose_value",
      value: function compose_value(value, coords) {
        var _this2 = this;

        if (!value || !value.reduce) return '';
        return value.reduce(function (result, val) {
          switch (val.type) {
            case 'text':
              {
                result += val.value;
                break;
              }

            case 'func':
              {
                var fname = val.name.substr(1);

                var fn = _this2.pick_func(fname);

                if (fn) {
                  coords.position = val.position;
                  var args = val.arguments.map(function (arg) {
                    if (fn.lazy) {
                      return function () {
                        for (var _len20 = arguments.length, extra = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
                          extra[_key20] = arguments[_key20];
                        }

                        return _this2.compose_argument(arg, coords, extra);
                      };
                    } else {
                      return _this2.compose_argument(arg, coords);
                    }
                  });
                  var output = apply_args(fn, coords, args);

                  if (!is_nil(output)) {
                    result += output;
                  }
                }
              }
          }

          return result;
        }, '');
      }
    }, {
      key: "compose_rule",
      value: function compose_rule(token, _coords, selector) {
        var _this3 = this;

        var coords = Object.assign({}, _coords);
        var prop = token.property;
        var value_group = token.value.reduce(function (ret, v) {
          var composed = _this3.compose_value(v, coords);

          if (composed) ret.push(composed);
          return ret;
        }, []);
        var value = value_group.join(', ');

        if (/^animation(\-name)?$/.test(prop)) {
          this.props.has_animation = true;

          if (coords.count > 1) {
            var count = coords.count;

            switch (prop) {
              case 'animation-name':
                {
                  value = value_group.map(function (n) {
                    return _this3.compose_aname(n, count);
                  }).join(', ');
                  break;
                }

              case 'animation':
                {
                  value = value_group.map(function (n) {
                    var group = (n || '').split(/\s+/);
                    group[0] = _this3.compose_aname(group[0], count);
                    return group.join(' ');
                  }).join(', ');
                }
            }
          }
        }

        if (prop == 'content') {
          if (!/["']|^none$|^(var|counter|counters|attr)\(/.test(value)) {
            value = "'".concat(value, "'");
          }
        }

        if (prop == 'transition') {
          this.props.has_transition = true;
        }

        var rule = "".concat(prop, ": ").concat(value, ";");
        rule = prefixer(prop, rule);

        if (prop == 'clip-path') {
          // fix clip bug
          rule += ';overflow: hidden;';
        }

        if (prop == 'width' || prop == 'height') {
          if (!is_special_selector(selector)) {
            rule += "--internal-cell-".concat(prop, ": ").concat(value, ";");
          }
        }

        if (Property[prop]) {
          var transformed = Property[prop](value, {
            is_special_selector: is_special_selector(selector)
          });

          switch (prop) {
            case '@grid':
              {
                if (is_host_selector(selector)) {
                  this.grid = transformed.grid;
                  rule = transformed.size || '';
                }

                break;
              }

            case '@place-cell':
              {
                if (!is_host_selector(selector)) {
                  rule = transformed;
                }
              }

            case '@use':
              {
                if (token.value.length) {
                  this.compose(coords, token.value);
                }

                rule = Property[prop](token.value);
              }

            default:
              {
                rule = transformed;
              }
          }
        }

        return rule;
      }
    }, {
      key: "compose",
      value: function compose(coords, tokens, initial) {
        var _this4 = this;

        this.coords.push(coords);
        (tokens || this.tokens).forEach(function (token, i) {
          if (token.skip) return false;
          if (initial && _this4.grid) return false;

          switch (token.type) {
            case 'rule':
              _this4.add_rule(_this4.compose_selector(coords), _this4.compose_rule(token, coords));

              break;

            case 'pseudo':
              {
                if (token.selector.startsWith(':doodle')) {
                  token.selector = token.selector.replace(/^\:+doodle/, ':host');
                }

                var special = is_special_selector(token.selector);

                if (special) {
                  token.skip = true;
                }

                token.selector.split(',').forEach(function (selector) {
                  var pseudo = token.styles.map(function (s) {
                    return _this4.compose_rule(s, coords, selector);
                  });
                  var composed = special ? selector : _this4.compose_selector(coords, selector);

                  _this4.add_rule(composed, pseudo);
                });
                break;
              }

            case 'cond':
              {
                var fn = Selector[token.name.substr(1)];

                if (fn) {
                  var args = token.arguments.map(function (arg) {
                    return _this4.compose_argument(arg, coords);
                  });
                  var result = apply_args(fn, coords, args);

                  if (result) {
                    _this4.compose(coords, token.styles);
                  }
                }

                break;
              }

            case 'keyframes':
              {
                if (!_this4.keyframes[token.name]) {
                  _this4.keyframes[token.name] = function (coords) {
                    return "\n              ".concat(join(token.steps.map(function (step) {
                      return "\n                ".concat(step.name, " {\n                  ").concat(join(step.styles.map(function (s) {
                        return _this4.compose_rule(s, coords);
                      })), "\n                }\n              ");
                    })), "\n            ");
                  };
                }
              }
          }
        });
      }
    }, {
      key: "output",
      value: function output() {
        var _this5 = this;

        Object.keys(this.rules).forEach(function (selector, i) {
          if (is_parent_selector(selector)) {
            _this5.styles.container += "\n          .container {\n            ".concat(join(_this5.rules[selector]), "\n          }\n        ");
          } else {
            var target = is_host_selector(selector) ? 'host' : 'cells';
            _this5.styles[target] += "\n          ".concat(selector, " {\n            ").concat(join(_this5.rules[selector]), "\n          }\n        ");
          }
        });
        var keyframes = Object.keys(this.keyframes);
        this.coords.forEach(function (coords, i) {
          keyframes.forEach(function (name) {
            var aname = _this5.compose_aname(name, coords.count);

            _this5.styles.keyframes += "\n          ".concat(maybe(i == 0, "@keyframes ".concat(name, " {\n              ").concat(_this5.keyframes[name](coords), "\n            }")), "\n          @keyframes ").concat(aname, " {\n            ").concat(_this5.keyframes[name](coords), "\n          }\n        ");
          });
        });
        return {
          props: this.props,
          styles: this.styles,
          grid: this.grid
        };
      }
    }]);

    return Rules;
  }();

  function generator(tokens, grid_size) {
    var rules = new Rules(tokens);
    var context = {};
    rules.compose({
      x: 1,
      y: 1,
      z: 1,
      count: 1,
      context: {},
      grid: {
        x: 1,
        y: 1,
        z: 1,
        count: 1
      }
    }, null, true);

    var _rules$output = rules.output(),
        grid = _rules$output.grid;

    if (grid) grid_size = grid;
    rules.reset();

    if (grid_size.z == 1) {
      for (var x = 1, count = 0; x <= grid_size.x; ++x) {
        for (var y = 1; y <= grid_size.y; ++y) {
          rules.compose({
            x: x,
            y: y,
            z: 1,
            count: ++count,
            grid: grid_size,
            context: context
          });
        }
      }
    } else {
      for (var z = 1, _count = 0; z <= grid_size.z; ++z) {
        rules.compose({
          x: 1,
          y: 1,
          z: z,
          count: ++_count,
          grid: grid_size,
          context: context
        });
      }
    }

    return rules.output();
  }

  var Doodle = /*#__PURE__*/function (_HTMLElement) {
    _inherits(Doodle, _HTMLElement);

    var _super = _createSuper(Doodle);

    function Doodle() {
      var _this6;

      _classCallCheck(this, Doodle);

      _this6 = _super.call(this);
      _this6.doodle = _this6.attachShadow({
        mode: 'open'
      });
      _this6.extra = {
        get_custom_property_value: _this6.get_custom_property_value.bind(_assertThisInitialized(_this6))
      };
      return _this6;
    }

    _createClass(Doodle, [{
      key: "connectedCallback",
      value: function connectedCallback(again) {
        var _this7 = this;

        setTimeout(function () {
          var compiled;
          var use = _this7.getAttribute('use') || '';
          if (use) use = "@use:".concat(use, ";");
          if (!_this7.innerHTML.trim() && !use) return false;

          try {
            var parsed = parse$1(use + _this7.innerHTML, _this7.extra);
            _this7.grid_size = parse_grid(_this7.getAttribute('grid'));
            compiled = generator(parsed, _this7.grid_size);
            compiled.grid && (_this7.grid_size = compiled.grid);

            _this7.build_grid(compiled);
          } catch (e) {
            _this7.innerHTML = '';
            console.error(e && e.message || 'Error in css-doodle.');
          }

          if (!again && _this7.hasAttribute('click-to-update')) {
            _this7.addEventListener('click', function (e) {
              return _this7.update();
            });
          }
        });
      }
    }, {
      key: "get_custom_property_value",
      value: function get_custom_property_value(name) {
        return getComputedStyle(this).getPropertyValue(name).trim().replace(/^\(|\)$/g, '');
      }
    }, {
      key: "cell",
      value: function cell(x, y, z) {
        var cell = document.createElement('div');
        cell.id = cell_id(x, y, z);
        return cell;
      }
    }, {
      key: "build_grid",
      value: function build_grid(compiled) {
        var _this8 = this;

        var _compiled$props = compiled.props,
            has_transition = _compiled$props.has_transition,
            has_animation = _compiled$props.has_animation;
        var _compiled$styles = compiled.styles,
            keyframes = _compiled$styles.keyframes,
            host = _compiled$styles.host,
            container = _compiled$styles.container,
            cells = _compiled$styles.cells;
        this.doodle.innerHTML = "\n      <style>\n        ".concat(this.style_basic(), "\n      </style>\n      <style class=\"style-keyframes\">\n        ").concat(keyframes, "\n      </style>\n      <style class=\"style-container\">\n        ").concat(this.style_size(), "\n        ").concat(host, "\n        ").concat(container, "\n      </style>\n      <style class=\"style-cells\">\n        ").concat(has_transition || has_animation ? '' : cells, "\n      </style>\n      <div class=\"container\"></div>\n    ");
        this.doodle.querySelector('.container').appendChild(this.html_cells());

        if (has_transition || has_animation) {
          setTimeout(function () {
            _this8.set_style('.style-cells', cells);
          }, 50);
        }
      }
    }, {
      key: "inherit_props",
      value: function inherit_props(p) {
        return get_props(/grid/).map(function (n) {
          return "".concat(n, ": inherit;");
        }).join('');
      }
    }, {
      key: "style_basic",
      value: function style_basic() {
        return "\n      * {\n        box-sizing: border-box;\n      }\n      *::after, *::before {\n        box-sizing: inherit;\n      }\n      :host {\n        display: block;\n        visibility: visible;\n        width: 1em;\n        height: 1em;\n      }\n      .container {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        display: grid;\n        ".concat(this.inherit_props(), "\n      }\n      .container div:empty {\n        position: relative;\n        line-height: 1;\n        display: grid;\n        place-content: center;\n      }\n    ");
      }
    }, {
      key: "style_size",
      value: function style_size() {
        var _this$grid_size = this.grid_size,
            x = _this$grid_size.x,
            y = _this$grid_size.y;
        return "\n      :host {\n        grid-template-rows: repeat(".concat(x, ", 1fr);\n        grid-template-columns: repeat(").concat(y, ", 1fr);\n      }\n    ");
      }
    }, {
      key: "html_cells",
      value: function html_cells() {
        var _this$grid_size2 = this.grid_size,
            x = _this$grid_size2.x,
            y = _this$grid_size2.y,
            z = _this$grid_size2.z;
        var root = document.createDocumentFragment();

        if (z == 1) {
          for (var i = 1; i <= x; ++i) {
            for (var j = 1; j <= y; ++j) {
              root.appendChild(this.cell(i, j, 1));
            }
          }
        } else {
          var temp = null;

          for (var _i2 = 1; _i2 <= z; ++_i2) {
            var cell = this.cell(1, 1, _i2);
            (temp || root).appendChild(cell);
            temp = cell;
          }

          temp = null;
        }

        return root;
      }
    }, {
      key: "set_style",
      value: function set_style(selector, styles) {
        var el = this.shadowRoot.querySelector(selector);
        el && (el.styleSheet ? el.styleSheet.cssText = styles : el.innerHTML = styles);
      }
    }, {
      key: "update",
      value: function update(styles) {
        var _this9 = this;

        var use = this.getAttribute('use') || '';
        if (use) use = "@use:".concat(use, ";");
        if (!styles) styles = this.innerHTML;
        this.innerHTML = styles;

        if (!this.grid_size) {
          this.grid_size = parse_grid(this.getAttribute('grid'));
        }

        var compiled = generator(parse$1(use + styles, this.extra), this.grid_size);

        if (compiled.grid) {
          var _compiled$grid = compiled.grid,
              x = _compiled$grid.x,
              y = _compiled$grid.y,
              z = _compiled$grid.z;
          var _this$grid_size3 = this.grid_size,
              gx = _this$grid_size3.x,
              gy = _this$grid_size3.y,
              gz = _this$grid_size3.z;

          if (gx !== x || gy !== y || gz !== z) {
            Object.assign(this.grid_size, compiled.grid);
            return this.build_grid(compiled);
          }

          Object.assign(this.grid_size, compiled.grid);
        } else {
          var grid = parse_grid(this.getAttribute('grid'));
          var _x = grid.x,
              _y = grid.y,
              _z = grid.z;
          var _this$grid_size4 = this.grid_size,
              _gx = _this$grid_size4.x,
              _gy = _this$grid_size4.y,
              _gz = _this$grid_size4.z;

          if (_gx !== _x || _gy !== _y || _gz !== _z) {
            Object.assign(this.grid_size, grid);
            return this.build_grid(generator(parse$1(use + styles, this.extra), this.grid_size));
          }
        }

        this.set_style('.style-keyframes', compiled.styles.keyframes);

        if (compiled.props.has_animation) {
          this.set_style('.style-cells', '');
          this.set_style('.style-container', '');
        }

        setTimeout(function () {
          _this9.set_style('.style-container', _this9.style_size() + compiled.styles.host + compiled.styles.container);

          _this9.set_style('.style-cells', compiled.styles.cells);
        });
      }
    }, {
      key: "grid",
      get: function get() {
        return Object.assign({}, this.grid_size);
      },
      set: function set(grid) {
        this.setAttribute('grid', grid);
        this.connectedCallback(true);
      }
    }, {
      key: "use",
      get: function get() {
        return this.getAttribute('use');
      },
      set: function set(use) {
        this.setAttribute('use', use);
        this.connectedCallback(true);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, old_val, new_val) {
        if (old_val == new_val) {
          return false;
        }

        if (name == 'grid' && old_val) {
          this.grid = new_val;
        }

        if (name == 'use' && old_val) {
          this.use = new_val;
        }
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ['grid', 'use'];
      }
    }]);

    return Doodle;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  if (!customElements.get('css-doodle')) {
    customElements.define('css-doodle', Doodle);
  }
});